// File: src/pages/Admin/Login.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

export default function AdminLogin() {
  const [email, setEmail]   = useState('');
  const [password, setPass] = useState('');
  const [error, setError]   = useState('');
  const navigate            = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    try {
      const { user } = await signInWithEmailAndPassword(auth, email, password);
      const snap = await getDoc(doc(db, 'admins', user.email));
      if (!snap.exists()) throw new Error('Not an admin');
      const { role } = snap.data();
      navigate(role === 'superadmin'
        ? '/admin/dashboard'
        : '/admin/tasks'
      );
    } catch (err) {
      setError(err.message);
      await auth.signOut();
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: '2rem auto', padding: '1rem', border: '1px solid #ccc' }}>
      <h2>Admin Sign-In</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <form onSubmit={handleSubmit}>
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{ width: '100%', marginBottom: 8 }}
        />

        <label>Password</label>
        <input
          type="password"
          value={password}
          onChange={e => setPass(e.target.value)}
          required
          style={{ width: '100%', marginBottom: 12 }}
        />

        <button type="submit" style={{ width: '100%', marginBottom: 8 }}>
          Log In
        </button>
      </form>

      <p style={{ marginTop: 12, fontSize: '0.9em' }}>
        No account? <Link to="/admin/signup">Sign up</Link>
      </p>
    </div>
  );
}
